export default __webpack_public_path__ + "static/media/up-arrow.4bf94f01.svg";